// externals
import { useSelector } from 'react-redux';

// store
import { vehicleDetailsSelectors } from '../store';

// hooks
import { useFuelEconomy } from './useFuelEconomy';
import { usePackagesEquipment } from './usePackagesEquipment';
import { useVehicleSpecifications } from './useVehicleSpecifications';
import { useWarrantyStatus } from './useWarrantyStatus';

/**
 * Returns ViewModel: aggregated vehicle details data for consumption by components.
 * Composes `useVehicleSpecifications`, `useFuelEconomy`, `useWarrantyStatus`, and `usePackagesEquipment`.
 * Note: Triggering the fetch is the responsibility of `useFetchVehicleDetails`.
 */
export const useVehicleDetails = () => {
    const isLoading = useSelector(vehicleDetailsSelectors.getIsLoading);
    const error = useSelector(vehicleDetailsSelectors.getError);
    const hasData = useSelector(vehicleDetailsSelectors.getHasVehicleData);
    const specifications = useVehicleSpecifications();
    const fuelEconomy = useFuelEconomy();
    const warrantyData = useWarrantyStatus();
    const packagesEquipment = usePackagesEquipment();

    return {
        isLoading,
        error,
        hasData,
        vehicleDetails: {
            specifications,
            fuelEconomy,
            warrantyData,
            packagesEquipment
        }
    };
};
